var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-3" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _vm.isMounted
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 customize-your-jewel pl-md-5" }, [
              _vm._v(_vm._s(_vm.$t("customize-your-jewel")))
            ]),
            _c("div", { staticClass: "col-12 d-md-none" }, [
              _c("div", { staticClass: "model-name" }, [
                _vm._v(_vm._s(_vm.$parent.currentJewelSelection.name))
              ]),
              _c("div", { staticClass: "model-sku" }, [
                _vm._v(_vm._s(_vm.$parent.selectedSku))
              ]),
              _c("div", { staticClass: "jewel-description" }, [
                _vm._v(_vm._s(_vm.$parent.jewelDescription))
              ]),
              _c("div", { staticClass: "read-more" }, [
                _c(
                  "span",
                  {
                    staticClass: "read-more-label",
                    on: {
                      click: function($event) {
                        _vm.readMore = !_vm.readMore
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("read-more-label")))]
                ),
                _vm.readMore
                  ? _c("div", { staticClass: "read-more-value" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("read-more-ama-description")) + " "
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _c(
              "div",
              { staticClass: "col-md-5 text-left px-5 order-md-1 order-2" },
              [
                _c("div", { staticClass: "d-none d-md-block" }, [
                  _c("div", { staticClass: "model-name" }, [
                    _vm._v(_vm._s(_vm.$parent.currentJewelSelection.name))
                  ]),
                  _c("div", { staticClass: "model-sku" }, [
                    _vm._v(_vm._s(_vm.$parent.selectedSku))
                  ]),
                  _c("div", { staticClass: "jewel-description" }, [
                    _vm._v(_vm._s(_vm.$parent.jewelDescription))
                  ]),
                  _c("div", { staticClass: "read-more" }, [
                    _c(
                      "span",
                      {
                        staticClass: "read-more-label",
                        on: {
                          click: function($event) {
                            _vm.readMore = !_vm.readMore
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("read-more-label")))]
                    ),
                    _vm.readMore
                      ? _c("div", { staticClass: "read-more-value" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("read-more-ama-description")) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                !_vm.showOnlyPublicPrice
                  ? _c("div", { staticClass: "wholesale-price" }, [
                      _c("span", { staticClass: "wholesale-price-label" }, [
                        _vm._v(_vm._s(_vm.$t("wholesale-price")))
                      ]),
                      _c("span", { staticClass: "wholesale-price-value" }, [
                        _vm._v("€ " + _vm._s(_vm.$parent.priceValue))
                      ])
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "retail-price" }, [
                  _c("span", { staticClass: "retail-price-label" }, [
                    _vm._v(_vm._s(_vm.$t("retail-price")))
                  ]),
                  _c("span", { staticClass: "retail-price-value" }, [
                    _vm._v("€ " + _vm._s(_vm.$parent.averageOrVatPriceValue))
                  ])
                ]),
                _c("div", { staticClass: "selector" }, [
                  _c("div", { staticClass: "selector-label" }, [
                    _vm._v(_vm._s(_vm.$t("choose-gold-color")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "selector-value" },
                    _vm._l(_vm.settings.golds.slice().reverse(), function(
                      gold
                    ) {
                      return _c(
                        "div",
                        { key: gold.id, staticClass: "gold-circle" },
                        [
                          _c("img", {
                            style: {
                              border:
                                _vm.settings.selectedGold == gold.id
                                  ? "2px solid"
                                  : ""
                            },
                            attrs: {
                              src: _vm.settings.baseImageUrl + gold.image
                            },
                            on: {
                              click: function($event) {
                                return _vm.settings.triggerToChange(
                                  gold.id,
                                  "0"
                                )
                              }
                            }
                          })
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _vm.settings.sizes && _vm.settings.sizes.length > 0
                  ? _c("div", { staticClass: "selector" }, [
                      _c("div", { staticClass: "selector-label" }, [
                        _vm._v(_vm._s(_vm.$t("choose-measure")))
                      ]),
                      _c("div", { staticClass: "selector-value" }, [
                        _c(
                          "select",
                          {
                            staticClass: "select-setting",
                            domProps: { value: _vm.settings.selectedSize },
                            on: {
                              change: function($event) {
                                return _vm.settings.triggerToChange(
                                  $event.target.value,
                                  "1"
                                )
                              }
                            }
                          },
                          [
                            _c("option", { domProps: { value: null } }),
                            _vm._l(_vm.settings.sizes, function(size) {
                              return _c(
                                "option",
                                {
                                  key: size.id,
                                  attrs: { disabled: size.disabled },
                                  domProps: { value: size.id }
                                },
                                [_vm._v(" " + _vm._s(size.label) + " ")]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._l(_vm.settings.stoneColorObj, function(valueObj) {
                  return valueObj.values.length > 1
                    ? _c("div", { key: valueObj.id, staticClass: "selector" }, [
                        _c(
                          "div",
                          {
                            staticClass: "selector-label",
                            staticStyle: { "border-left": "none !important" }
                          },
                          [_vm._v(_vm._s(_vm.$t("stoneColor")))]
                        ),
                        _c(
                          "div",
                          { staticClass: "selector-value" },
                          _vm._l(valueObj.values, function(stone) {
                            return _c("div", { key: stone.id }, [
                              _c("img", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.top",
                                    value: {
                                      content: stone.label,
                                      trigger: "hover click focus",
                                      delay: { show: "200", hide: "500" }
                                    },
                                    expression:
                                      "{content: stone.label,trigger: 'hover click focus', delay: { show: '200', hide: '500' }}",
                                    modifiers: { top: true }
                                  }
                                ],
                                staticClass: "rounded-circle cursor-pointer",
                                class: { disableImg: stone.disabled },
                                style: {
                                  border:
                                    _vm.settings.selectedStoneObj[
                                      valueObj.type
                                    ] == stone.id
                                      ? "1px solid"
                                      : "",
                                  opacity: stone.disabled ? "0.2" : "1"
                                },
                                attrs: {
                                  src: _vm.$parent.baseImageUrl + stone.image,
                                  height: "40",
                                  width: "40"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.settings.triggerToChange(
                                      stone.id,
                                      "stone",
                                      valueObj.type
                                    )
                                  }
                                }
                              })
                            ])
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                }),
                _vm._l(_vm.settings.stoneSizeObj, function(objSize) {
                  return _c(
                    "div",
                    { key: objSize.id, staticClass: "selector" },
                    [
                      _c("div", { staticClass: "selector-label" }, [
                        _vm._v(_vm._s(_vm.$t("choose-carat")))
                      ]),
                      _c("div", { staticClass: "selector-value" }, [
                        _c(
                          "select",
                          {
                            staticClass: "select-setting",
                            domProps: {
                              value:
                                _vm.settings.selectedStoneSizeObj[objSize.type]
                            },
                            on: {
                              change: function($event) {
                                return _vm.settings.triggerToChange(
                                  $event.target.value,
                                  "size",
                                  objSize.type
                                )
                              }
                            }
                          },
                          [
                            _c("option", { domProps: { value: null } }),
                            _vm._l(objSize.values, function(size) {
                              return _c(
                                "option",
                                {
                                  key: size.id,
                                  attrs: { disabled: size.disabled },
                                  domProps: { value: size.id }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        objSize.sizeUnit === "MM"
                                          ? size.label
                                          : parseFloat(size.label).toFixed(2)
                                      ) +
                                      " " +
                                      _vm._s(
                                        objSize.sizeUnit === "MM" ? "mm" : "ct"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ]
                  )
                }),
                _vm.settings.isEngraveVisible
                  ? _c("div", { staticClass: "engraving-selector" }, [
                      _c("div", { staticClass: "selector" }, [
                        _c("div", { staticClass: "selector-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("customizeEngraving")) +
                              " (+" +
                              _vm._s(
                                _vm.settings.currentJewelSelection.writingPrice
                                  .toFixed(2)
                                  .replace(".", ",")
                              ) +
                              "€)"
                          )
                        ]),
                        _c("div", { staticClass: "selector-value" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.incisione,
                                expression: "settings.incisione"
                              }
                            ],
                            staticClass: "incisione-checkbox",
                            attrs: {
                              type: "checkbox",
                              disabled: !_vm.$parent.jewelDescription
                            },
                            domProps: {
                              checked: Array.isArray(_vm.settings.incisione)
                                ? _vm._i(_vm.settings.incisione, null) > -1
                                : _vm.settings.incisione
                            },
                            on: {
                              click: function($event) {
                                return _vm.settings.incisioneSelection(
                                  $event.target.checked
                                )
                              },
                              change: function($event) {
                                var $$a = _vm.settings.incisione,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.settings,
                                        "incisione",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.settings,
                                        "incisione",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.settings, "incisione", $$c)
                                }
                              }
                            }
                          })
                        ])
                      ]),
                      _vm.settings.incisione
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.settings.incisioneLabel,
                                expression: "settings.incisioneLabel"
                              }
                            ],
                            staticClass: "engraving-input",
                            style: {
                              border:
                                _vm.settings.incisione &&
                                !_vm.settings.incisioneLabel
                                  ? "1px solid red"
                                  : ""
                            },
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("max10Char", {
                                char: _vm.settings.currentCategory
                                  ? _vm.settings.currentCategory.maxChars || 10
                                  : 10
                              })
                            },
                            domProps: { value: _vm.settings.incisioneLabel },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.settings,
                                    "incisioneLabel",
                                    $event.target.value
                                  )
                                },
                                function($event) {
                                  return _vm.settings.incisioneSelectionLabel()
                                }
                              ]
                            }
                          })
                        : _vm._e()
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "selector" }, [
                  _c("div", { staticClass: "selector-label" }, [
                    _vm._v(_vm._s(_vm.$t("quantity")))
                  ]),
                  _c("div", { staticClass: "selector-value" }, [
                    _c(
                      "span",
                      {
                        staticClass: "quantity-selector",
                        on: {
                          click: function($event) {
                            return _vm.changeQuantity(-1)
                          }
                        }
                      },
                      [_vm._v("-")]
                    ),
                    _c("span", { staticClass: "quantity-value" }, [
                      _vm._v(_vm._s(_vm.$parent.quantity))
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "quantity-selector",
                        on: {
                          click: function($event) {
                            return _vm.changeQuantity(+1)
                          }
                        }
                      },
                      [_vm._v("+")]
                    )
                  ])
                ]),
                _vm.$parent.credential.apiEncryptedUser
                  ? _c("div", [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$parent.note,
                            expression: "$parent.note"
                          }
                        ],
                        staticClass: "item-note",
                        attrs: { placeholder: _vm.$t("note.placeholder") },
                        domProps: { value: _vm.$parent.note },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.$parent, "note", $event.target.value)
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm.$parent.selectedJewel
                  ? _c("div", { staticClass: "estimated-shipping" }, [
                      _c("div", { staticClass: "estimated-shipping-label" }, [
                        _vm._v(_vm._s(_vm.$t("plannedShipment")))
                      ]),
                      _c("div", { staticClass: "estimated-shipping-value" }, [
                        _vm._v(_vm._s(_vm.$parent.selectedJewel.shipmentDate))
                      ])
                    ])
                  : _vm._e(),
                _c(
                  "button",
                  {
                    staticClass: "btn add-to-basket-btn",
                    class: {
                      disabled:
                        _vm.$parent.addedToBasket || !_vm.$parent.selectedJewel
                    },
                    attrs: {
                      disabled:
                        !_vm.$parent.selectedJewel ||
                        _vm.$parent.addedToBasket ||
                        !_vm.$parent.jewelDescription ||
                        (_vm.settings.incisione && !_vm.settings.incisioneLabel)
                    },
                    on: { click: _vm.$parent.addToBasket }
                  },
                  [
                    _vm.$parent.addedToBasket
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("addedToBasket")))])
                      : _c("span", [_vm._v(_vm._s(_vm.$t("addToBasket")))])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "weigth-alert",
                    attrs: {
                      title: _vm.$parent.selectedSku
                        ? _vm.$parent.selectedSku +
                          _vm.$parent.additionalSkuLabelArray.join("")
                        : null
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("weigth-alert")) + " ")]
                )
              ],
              2
            ),
            _c("div", { staticClass: "col-md-7 order-md-2 order-1" }, [
              _vm.$parent.jewelDescription &&
              _vm.$parent.imagesAvailable.length + _vm.$parent.videos.length >=
                4 &&
              _vm.isDesktop
                ? _c(
                    "div",
                    { staticClass: "row m-0" },
                    [
                      _vm._l(_vm.firstGroupImages, function(image, index) {
                        return _c(
                          "div",
                          { staticClass: "col-md-6 col-jewel-img-container" },
                          [
                            _c("div", { staticClass: "jewel-img-container" }, [
                              _c("div", { staticClass: "jewel-img-div" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.$parent.baseImageUrl + image
                                  }
                                })
                              ]),
                              _c("div", { staticClass: "jewel-img-div-border" })
                            ])
                          ]
                        )
                      }),
                      _vm._l(_vm.$parent.videos, function(video, index) {
                        return _c(
                          "div",
                          { staticClass: "col-md-6 col-jewel-img-container" },
                          [
                            _c("div", { staticClass: "jewel-img-container" }, [
                              _c("div", { staticClass: "jewel-img-div" }, [
                                _c("video", {
                                  ref: "videoRef",
                                  refInFor: true,
                                  staticClass: "video-container",
                                  attrs: {
                                    id: "video-container",
                                    width: "100%",
                                    src: _vm.$parent.baseVideoUrl + video,
                                    muted: "",
                                    autoplay: "",
                                    loop: "",
                                    playsinline: ""
                                  },
                                  domProps: { muted: true }
                                })
                              ]),
                              _c("div", { staticClass: "jewel-img-div-border" })
                            ])
                          ]
                        )
                      }),
                      _vm._l(_vm.secondGroupImages, function(image, index) {
                        return _c(
                          "div",
                          { staticClass: "col-md-6 col-jewel-img-container" },
                          [
                            _c("div", { staticClass: "jewel-img-container" }, [
                              _c("div", { staticClass: "jewel-img-div" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.$parent.baseImageUrl + image
                                  }
                                })
                              ]),
                              _c("div", { staticClass: "jewel-img-div-border" })
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.$parent.jewelDescription &&
              (_vm.$parent.imagesAvailable.length + _vm.$parent.videos.length <
                4 ||
                !_vm.isDesktop)
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-12 order-md-2 mb-3",
                        class: {
                          "col-md-9":
                            _vm.$parent.imagesAvailable.length +
                              _vm.$parent.videos.length >
                            1
                        }
                      },
                      [
                        _c("div", [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "swiper",
                                  rawName: "v-swiper:swiperTop",
                                  value: _vm.swiperTopOptions,
                                  expression: "swiperTopOptions",
                                  arg: "swiperTop"
                                }
                              ],
                              staticClass: "main-swiper-container",
                              on: { slideChange: _vm.changeSwiperTopIndex }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "swiper-wrapper" },
                                [
                                  _vm._l(_vm.firstGroupImages, function(
                                    image,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: image,
                                        staticClass: "swiper-slide"
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "w-100",
                                          attrs: {
                                            src:
                                              _vm.$parent.baseImageUrl + image
                                          }
                                        })
                                      ]
                                    )
                                  }),
                                  _vm._l(_vm.$parent.videos, function(video) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "swiper-slide swiper-slide-video"
                                      },
                                      [
                                        _c("video", {
                                          ref: "videoRef",
                                          refInFor: true,
                                          staticClass: "video-container",
                                          attrs: {
                                            id: "video-container",
                                            width: "100%",
                                            src:
                                              _vm.$parent.baseVideoUrl + video,
                                            muted: "",
                                            autoplay: "",
                                            loop: "",
                                            playsinline: ""
                                          },
                                          domProps: { muted: true }
                                        })
                                      ]
                                    )
                                  }),
                                  _vm._l(_vm.secondGroupImages, function(
                                    image,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: image,
                                        staticClass: "swiper-slide"
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "w-100",
                                          attrs: {
                                            src:
                                              _vm.$parent.baseImageUrl + image
                                          }
                                        })
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm.$parent.imagesAvailable.length +
                      _vm.$parent.videos.length >
                    1
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-3 order-md-1 text-left text-md-right pr-0"
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "swiper",
                                    rawName: "v-swiper:swiperThumbs",
                                    value: _vm.swiperThumbsOptions,
                                    expression: "swiperThumbsOptions",
                                    arg: "swiperThumbs"
                                  }
                                ],
                                ref: "swiperThumbs",
                                staticClass:
                                  "pr-2 pb-2 swiper-thumbs swiper-thumbs-desktop d-md-block"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "swiper-wrapper" },
                                  [
                                    _vm._l(_vm.firstGroupImages, function(
                                      image,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: image,
                                          staticClass: "swiper-slide",
                                          class: {
                                            active:
                                              index == _vm.thumbsActiveIndex
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "border-img",
                                            attrs: {
                                              src:
                                                _vm.$parent.baseImageUrl + image
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.slideSwiperTopTo(
                                                  index
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    }),
                                    _vm._l(_vm.$parent.videos, function(
                                      video,
                                      videoIndex
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass: "swiper-slide",
                                          class: {
                                            active:
                                              _vm.firstGroupImages.length +
                                                videoIndex ==
                                              _vm.thumbsActiveIndex
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "border-img video-icon",
                                            attrs: {
                                              src: require("../../assets/video-icon.png")
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.slideSwiperTopTo(
                                                  _vm.firstGroupImages.length +
                                                    videoIndex
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    }),
                                    _vm._l(_vm.secondGroupImages, function(
                                      image,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: image,
                                          staticClass: "swiper-slide",
                                          class: {
                                            active:
                                              _vm.firstGroupImages.length +
                                                _vm.$parent.videos.length +
                                                index ==
                                              _vm.thumbsActiveIndex
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "border-img",
                                            attrs: {
                                              src:
                                                _vm.$parent.baseImageUrl + image
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.slideSwiperTopTo(
                                                  _vm.firstGroupImages.length +
                                                    _vm.$parent.videos.length +
                                                    index
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _c(
              "div",
              { staticClass: "col-12 order-3 mt-5" },
              [_c("related-jewels")],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }